import React, { useContext } from "react";
import _ from "lodash";
import { AppContext } from "../../../context/AppContext";
import CustomCalendar from "../../CustomCalender";
import moment from "moment";
import { useRef } from "react";
import { checkModuleGeneralPermission } from "../../../helpers/helpers";
import useStorage from "../../../helpers/useStorage";
import {
  defaultFromDateFilterValue,
  defaultToDateFilterValue,
} from "../../../helpers/utils";
import { reportDatewoTimeFormat } from "../../../constants";

const ReportFilter = ({
  setFilterChanged,
  setCurrentPageNumber,
  onBeforeDateChange,
  handleUpdateKey,
  onAfterDateChange,
  onExport,
  buttonVisibility,
}) => {
  const { setToStorage, getFromStorage, removeFromStorage } = useStorage();
  const { userRoleDetails } = useContext(AppContext);

  const [beforeDate, setBeforeDate] = React.useState(
    getFromStorage("bca_report_filter_before_date") ??
      defaultFromDateFilterValue(reportDatewoTimeFormat)
  );
  const [afterDate, setAfterDate] = React.useState(
    getFromStorage("bca_report_filter_after_date") ??
      defaultToDateFilterValue(reportDatewoTimeFormat)
  );
  const afterDateRef = useRef(null);
  const beforeDateRef = useRef(null);

  const applyFilter = () => {
    removeFromStorage();
    setToStorage(
      {
        bca_report_filter_before_date: beforeDate ?? "",
        bca_report_filter_after_date: afterDate ?? "",
      },
      false
    );

    onBeforeDateChange(beforeDate ?? undefined);
    onAfterDateChange(afterDate ?? undefined);
    setCurrentPageNumber(1);
    handleUpdateKey();
  };
  const onFilterChange = (option) => {
    const { name, value, label } = option;

    setFilterChanged(true);
    switch (name) {
      case "before":
        setBeforeDate(
          value ? moment(value).format(reportDatewoTimeFormat) : undefined
        );
        break;

      case "after":
        setAfterDate(
          value ? moment(value).format(reportDatewoTimeFormat) : undefined
        );
        break;

      default:
        break;
    }
  };

  const handleSingleFieldReset = (field) => {
    switch (field) {
      case "beforeDate":
        setBeforeDate(undefined);
        beforeDateRef.current.handleChange(undefined);
        onBeforeDateChange(undefined);
        return;

      case "afterDate":
        setAfterDate(undefined);
        afterDateRef.current.handleChange(undefined);
        onAfterDateChange(undefined);
        return;

      default:
        return;
    }
  };

  const resetFilterOptions = () => {
    setFilterChanged(false);
    setBeforeDate(defaultFromDateFilterValue(reportDatewoTimeFormat));
    setAfterDate(defaultToDateFilterValue(reportDatewoTimeFormat));
    onBeforeDateChange(defaultFromDateFilterValue(reportDatewoTimeFormat));
    beforeDateRef.current.handleChange(
      defaultFromDateFilterValue(reportDatewoTimeFormat)
    );
    afterDateRef.current.handleChange(
      defaultToDateFilterValue(reportDatewoTimeFormat)
    );
    onAfterDateChange(defaultToDateFilterValue(reportDatewoTimeFormat));
    setCurrentPageNumber(1);
    removeFromStorage();
    // handleUpdateKey();
  };

  return (
    <div className="reports-filter-section pb-3 position-relative">
      <div className="row mb-2 ">
        <div className="col-12 col-sm-12 col-md-6 col-lg-6 mb-2">
          <span>Report Range</span>
          <div className="d-flex w-100">
            <div
              className={`w-100 ${
                !beforeDate && afterDate ? "hasValidationError" : ""
              }`}
            >
              <CustomCalendar
                maxDate={afterDate ? new Date(afterDate) : moment().toDate()}
                ref={beforeDateRef}
                selected={beforeDate === undefined ? "" : new Date(beforeDate)}
                onChange={(date) =>
                  onFilterChange({ name: "before", value: date, label: "" })
                }
                className="form-control"
                placeholderText={reportDatewoTimeFormat}
                dateFormat={reportDatewoTimeFormat}
                isClearable={true}
                onClear={() => handleSingleFieldReset("beforeDate")}
              />
            </div>
            <div className="px-2 d-flex align-items-center"> - </div>
            <div
              className={`w-100 ${
                beforeDate && !afterDate ? "hasValidationError" : ""
              }`}
            >
              <CustomCalendar
                minDate={beforeDate === undefined ? "" : new Date(beforeDate)}
                ref={afterDateRef}
                maxDate={moment().toDate()}
                selected={afterDate === undefined ? "" : new Date(afterDate)}
                onChange={(date) =>
                  onFilterChange({ name: "after", value: date, label: "" })
                }
                className="form-control"
                placeholderText={reportDatewoTimeFormat}
                dateFormat={reportDatewoTimeFormat}
                isClearable={true}
                onClear={() => handleSingleFieldReset("afterDate")}
              />
            </div>
          </div>
        </div>

        <div className="col-12 col-sm-6 col-md-6 col-lg-6 mb-2 d-flex justify-content-end flx-end">
          <span className="show-lg">&nbsp;</span>
          <div className="btn-cover ">
            <button
              onClick={() => applyFilter()}
              className="btn btn-secondary rounded-0 ml-1 "
            >
              Apply
            </button>
            <button
              onClick={resetFilterOptions}
              className="btn btn-secondary reset rounded-0 ml-1 "
            >
              <i className="iconsminds-repeat-2"></i>
            </button>
            {checkModuleGeneralPermission(
              userRoleDetails,
              "man-hour-report",
              "export_report"
            ) && (
              <button
                onClick={onExport}
                className="btn btn-secondary rounded-0 ml-1"
                disabled={buttonVisibility}
              >
                Export
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportFilter;
